import React, { useState } from 'react';
import { toast } from 'react-toastify';

const EditModal = ({ light, onSave, onCancel }) => {
  const [formData, setFormData] = useState({ ...light });
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = () => {
    setIsSaving(true);
    onSave(light.id, formData, (success) => {
      setIsSaving(false);
      if (success) {
          toast.success('Chỉnh sửa đèn thành công!', {
          position: 'top-center',
          autoClose: 5000,
        });
        onCancel(); // Đóng modal sau khi thành công
      } else {
          toast.error('Lỗi khi chỉnh sửa đèn. Vui lòng thử lại!', {
          position: 'top-center',
          autoClose: 5000,
        });
      }
    });
  };

  const handleCancel = () => {
    //console.log('Closing EditModal');
    onCancel();
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <div className="bg-blue-500 text-white p-2 rounded-t-lg">
          <h3 className="text-lg font-semibold mb-0">Chỉnh sửa đèn giao thông</h3>
        </div>
        <div className="modal-body">
          <div className="grid grid-cols-1 gap-4">
            <div className="flex flex-col gap-1">
              <label className="font-bold text-gray-800 text-sm mb-0">Tên đèn</label>
              <input
                type="text"
                placeholder="Tên đèn"
                value={formData.name || ''}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="border p-2 rounded w-full"
              />
            </div>
            <fieldset className="border rounded-lg p-4">
              <legend className="text-base font-semibold">Chu kỳ đèn</legend>
              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col gap-1">
                  <label className="font-bold text-gray-800 text-sm mb-0">Thời gian đỏ</label>
                  <input
                    type="number"
                    placeholder="Thời gian đỏ (s)"
                    value={formData.cycle?.red_duration || 30}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        cycle: { ...formData.cycle, red_duration: parseInt(e.target.value) || 0 },
                      })
                    }
                    className="border p-2 rounded w-full"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="font-bold text-gray-800 text-sm mb-0">Thời gian vàng</label>
                  <input
                    type="number"
                    placeholder="Thời gian vàng (s)"
                    value={formData.cycle?.yellow_duration || 5}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        cycle: { ...formData.cycle, yellow_duration: parseInt(e.target.value) || 0 },
                      })
                    }
                    className="border p-2 rounded w-full"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="font-bold text-gray-800 text-sm mb-0">Thời gian xanh</label>
                  <input
                    type="number"
                    placeholder="Thời gian xanh (s)"
                    value={formData.cycle?.green_duration || 25}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        cycle: { ...formData.cycle, green_duration: parseInt(e.target.value) || 0 },
                      })
                    }
                    className="border p-2 rounded w-full"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="font-bold text-gray-800 text-sm mb-0">Độ lệch thời gian</label>
                  <input
                    type="number"
                    placeholder="Độ lệch (s)"
                    value={formData.offset || 0}
                    onChange={(e) => setFormData({ ...formData, offset: parseInt(e.target.value) || 0 })}
                    className="border p-2 rounded w-full"
                  />
                </div>
              </div>
            </fieldset>
            <fieldset className="border rounded-lg p-4">
              <legend className="text-base font-semibold">Tọa độ</legend>
              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col gap-1">
                  <label className="font-bold text-gray-800 text-sm mb-0">Vĩ độ (Latitude)</label>
                  <input
                    type="number"
                    step="0.000001"
                    placeholder="Vĩ độ"
                    value={formData.latitude || 0}
                    onChange={(e) => setFormData({ ...formData, latitude: parseFloat(e.target.value) || 0 })}
                    className="border p-2 rounded w-full"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="font-bold text-gray-800 text-sm mb-0">Kinh độ (Longitude)</label>
                  <input
                    type="number"
                    step="0.000001"
                    placeholder="Kinh độ"
                    value={formData.longitude || 0}
                    onChange={(e) => setFormData({ ...formData, longitude: parseFloat(e.target.value) || 0 })}
                    className="border p-2 rounded w-full"
                  />
                </div>
              </div>
            </fieldset>
          </div>
          <div className="mt-4 flex justify-end space-x-2">
            <button
              onClick={handleSave}
              disabled={isSaving}
              className={`bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 ${
                isSaving ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {isSaving ? 'Đang lưu' : 'Lưu'}
            </button>
            <button
              onClick={handleCancel}
              className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Đóng cửa sổ
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditModal;